import _ from 'lodash';
import { types, getSnapshot } from 'mobx-state-tree';
import QueryFilter, { newQueryFilterSnapshot } from './QueryFilter';
import QuerySorting from './QuerySorting';
import resolveComparator from '../query/helpers/ComparatorResolver';
var QueryParameters = types.model({
    filters: types.optional(types.array(QueryFilter), []),
    sortings: types.optional(types.array(QuerySorting), []),
    take: types.optional(types.maybe(types.number), 50),
    total: types.maybe(types.number)
})
    .named('QueryParameters')
    .volatile(function (_self) { return ({ filterGroups: new Map() }); })
    .views(function (self) { return ({
    hasFilter: function (property) {
        return self.filters.find(function (x) { return x.property === property; }) !== undefined;
    },
    get hasSorting() {
        return self.sortings.length > 0;
    },
    get hasSearchAfter() {
        return self.sortings.find(function (x) { return x.searchAfter !== undefined; }) !== undefined;
    },
    getSorting: function (orderBy) {
        return self.sortings.find(function (x) { return x.orderBy === orderBy; });
    },
    getLoadMoreToken: function (items) {
        return JSON.stringify(getSnapshot(self)) + "_" + items.length;
    },
    getFilter: function (property, comparator) {
        return self.filters.find(function (x) { return x.property === property && (comparator === undefined || x.comparator === resolveComparator(comparator)); });
    }
}); })
    .actions(function (self) { return ({
    withTake: function (take) {
        self.take = take;
        return self;
    },
    withoutTake: function () {
        self.take = undefined;
        return self;
    },
    removeFilter: function (filterOrProperty) {
        if (typeof filterOrProperty === 'string') {
            self.filters.replace(self.filters.filter(function (x) { return x.property !== filterOrProperty; }));
        }
        else {
            self.filters.remove(filterOrProperty);
        }
    },
    clearFilters: function () {
        self.filters.clear();
    },
    addFilter: function (filter) {
        self.filters.push(filter);
    },
    putFilter: function (property, value, comparator, expressionTreeNodeId, uniqueComparator) {
        if (expressionTreeNodeId === void 0) { expressionTreeNodeId = 0; }
        if (uniqueComparator === void 0) { uniqueComparator = false; }
        var existingFilter = self.filters.find(function (x) { return x.property === property && (!uniqueComparator || x.comparator === resolveComparator(comparator)); });
        if (existingFilter) {
            existingFilter.setValue(value);
            existingFilter.setComparator(comparator);
            existingFilter.expressionTreeNodeId = expressionTreeNodeId;
        }
        else {
            self.filters.push(QueryFilter.create(newQueryFilterSnapshot(property, value, comparator, expressionTreeNodeId)));
        }
        return self;
    },
    addFilterGroup: function (properties, filterGroupId, value, comparator, expressionTreeNodeId) {
        var _this = this;
        if (expressionTreeNodeId === void 0) { expressionTreeNodeId = 0; }
        var existingFilterGroup = self.filterGroups.get(filterGroupId);
        if (existingFilterGroup) {
            self.filterGroups.delete(filterGroupId);
        }
        self.filterGroups.set(filterGroupId, properties);
        properties.forEach(function (property) {
            _this.putFilter(property, value, comparator, expressionTreeNodeId);
        });
        return self;
    },
    updateFilterGroup: function (filterGroupId, value, comparator, expressionTreeNodeId) {
        var existingFilterGroup = self.filterGroups.get(filterGroupId);
        if (!existingFilterGroup) {
            console.error("Can not update filter group with filterGroupId " + filterGroupId + ", because it does not exists!");
            return self;
        }
        existingFilterGroup.forEach(function (property) {
            var existingFilter = self.filters.find(function (x) { return x.property === property; });
            if (!existingFilter) {
                // should not happen
                return;
            }
            existingFilter.setValue(value);
            if (comparator) {
                existingFilter.setComparator(comparator);
            }
            if (expressionTreeNodeId) {
                existingFilter.expressionTreeNodeId = expressionTreeNodeId;
            }
        });
        return self;
    },
    // when the sorting changes the searchAfter values have to be removed
    sortingHasChanged: function () {
        self.sortings.forEach(function (sorting) { return sorting.removeSearchAfter(); });
    },
    /**
     * Replaces the first sorting property
     * @param orderBy
     * @param sortOrder
     */
    putSorting: function (orderBy, sortOrder) {
        var sorting = self.sortings[0];
        if (!sorting) {
            sorting = QuerySorting.create({
                orderBy: orderBy
            });
            self.sortings.push(sorting);
        }
        else {
            sorting.setOrderBy(orderBy);
        }
        if (sortOrder) {
            sorting.setSortOrder(sortOrder);
        }
        this.sortingHasChanged();
    },
    withSorting: function (orderBy, sortOrder) {
        if (sortOrder === void 0) { sortOrder = 'ascending'; }
        var querySorting = QuerySorting.create({
            orderBy: orderBy
        });
        querySorting.setSortOrder(sortOrder);
        self.sortings.push(querySorting);
        return self;
    },
    setSortOrderOnAllSortings: function (sortOrder) {
        self.sortings.forEach(function (x) {
            x.setSortOrder(sortOrder);
            x.removeSearchAfter();
        });
    },
    setSearchAfterFromItems: function (sortedItems) {
        var last = _.last(sortedItems);
        if (last) {
            this.setSearchAfter(last);
        }
        else {
            this.removeSearchAfter();
        }
        return self;
    },
    setSearchAfter: function (lastItem) {
        if (self.sortings.length === 0) {
            console.warn('setSearchAfter was called, but the query parameters not contains any sorting! Please check your QueryParameters again, the QueryParameters are: ', self);
        }
        self.sortings.forEach(function (querySorting) {
            querySorting.setSearchAfter(_.property(querySorting.orderBy)(lastItem));
        });
        return self;
    },
    removeSearchAfter: function () {
        self.sortings.forEach(function (querySorting) { return querySorting.removeSearchAfter(); });
        return self;
    }
}); });
export default QueryParameters;
//# sourceMappingURL=QueryParameters.js.map